module.exports = __webpack_public_path__ + "media/images/gallery/eclipse_on-834e961137a2517169372d8f61f2823b.gif";